module.exports = __webpack_public_path__ + "static/img/w-2.a3978a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/worldView/w-2.jpg
// module id = SHIZ
// module chunks = 1